import { render } from "./BrandBalanceAlert.vue?vue&type=template&id=dc25fbe0&scoped=true"
import script from "./BrandBalanceAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandBalanceAlert.vue?vue&type=script&setup=true&lang=js"

import "./BrandBalanceAlert.vue?vue&type=style&index=0&id=dc25fbe0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc25fbe0"],['__file',"resources/js/vue/domain/invoice/components/shared/BrandBalanceAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc25fbe0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc25fbe0', __exports__)) {
    api.reload('dc25fbe0', __exports__)
  }
  
  module.hot.accept("./BrandBalanceAlert.vue?vue&type=template&id=dc25fbe0&scoped=true", () => {
    api.rerender('dc25fbe0', render)
  })

}


export default __exports__